import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon7: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M5.843 0c.938 0 1.778.584 2.107 1.465l.77 2.071a2.249 2.249 0 0 1-1.235 2.855l-2.186.919c1.499 2.735 4.667 5.907 7.391 7.392l.919-2.186a2.247 2.247 0 0 1 2.855-1.236l2.07.77A2.248 2.248 0 0 1 20 14.157v3.229A2.614 2.614 0 0 1 17.385 20C7.783 20 0 12.216 0 2.615A2.614 2.614 0 0 1 2.614 0h3.229Zm0 1H2.614C1.722 1 1 1.723 1 2.615 1 11.664 8.335 19 17.385 19c.892 0 1.615-.722 1.615-1.614v-3.229c0-.521-.324-.988-.813-1.169l-2.072-.77a1.246 1.246 0 0 0-1.584.685l-1.128 2.685a.5.5 0 0 1-.681.255l-.057-.028c-3.164-1.547-6.97-5.367-8.509-8.538a.5.5 0 0 1 .256-.679l2.685-1.129c.616-.259.919-.958.686-1.585l-.77-2.07A1.25 1.25 0 0 0 5.843 1ZM10 0c5.523 0 10 4.477 10 10a.5.5 0 1 1-1 0 9 9 0 0 0-9-9 .5.5 0 1 1 0-1Zm0 2.429A7.571 7.571 0 0 1 17.57 10a.5.5 0 1 1-1 0A6.572 6.572 0 0 0 10 3.429a.5.5 0 1 1 0-1Z"
      />
    </Svg>
  )
}
